import { w } from '@tinkoff/statist-page-data';
var NativeBridge = /** @class */ (function () {
    function NativeBridge() {
    }
    NativeBridge.prototype.isConnected = function () {
        if (typeof this.nativeSDK !== 'undefined') {
            return true;
        }
        var nativeSDK = w.statistNativeSdk;
        if (typeof nativeSDK !== 'object') {
            return false;
        }
        var version = nativeSDK.version;
        if (typeof version !== 'string') {
            return false;
        }
        var interfaceVersion = version.split('.')[0];
        if (interfaceVersion !== '1') {
            return false;
        }
        this.nativeSDK = nativeSDK;
        return true;
    };
    NativeBridge.prototype.getSessionId = function () {
        if (this.isConnected()) {
            return this.nativeSDK.getSessionId();
        }
        return null;
    };
    NativeBridge.prototype.notifyEventHappened = function () {
        if (this.isConnected()) {
            return this.nativeSDK.notifyEventHappened();
        }
    };
    return NativeBridge;
}());
export { NativeBridge };
//# sourceMappingURL=native-bridge.js.map